/**
 * Generated bundle index. Do not edit.
 */

export {NgxPhoneMaskBrModule} from './public_api';

export {NgxPhoneMaskBrDirective as ɵa} from './src/app/ngx-phone-mask-br/ngx-phone-mask-br.directive';